import React from "react";
import { Link } from "react-router-dom";

const PopUp = ({ title, descriptions, showbuttons, data, showToogle, onClose, children }) => {
  if (!showToogle) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white p-6 rounded-xl w-full max-w-lg sm:max-w-2xl lg:max-w-3xl relative shadow-lg max-h-[90vh] overflow-y-auto">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 bg-gray-200 hover:bg-gray-300 p-2 rounded"
        >
          <svg
            className="w-6 h-6 text-gray-800"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18 17.94 6M18 18 6.06 6"
            />
          </svg>
        </button>

        {/* Content */}

        {data && (
          <>
            <h3 className="border-box mx-auto w-fit bg-orange-300 px-5 py-2 rounded-lg text-lg sm:text-xl font-bold mb-4 text-center transition-transform duration-300 hover:scale-105">
              {data.heading}
            </h3>


            <p className="text-gray-700 whitespace-pre-line text-sm sm:text-base mb-6">

              <p>{data.descriptions}</p>
              {data?.keyPoint ? (<>
                <h4 className="pt-5 pb-2 text-[16px] font-bold">
                  Key highlights :
                </h4>
              </>) : ""}
              <p className="relative left-3">{data.keyPoint}</p>
            </p>
          </>
        )}


        <div className="flex flex-col items-center">
          <div className="flex flex-col gap-3 text-center">
            <h1 className="text-xl sm:text-2xl text-orange-500 font-semibold">
              {title}
            </h1>
            <p className="text-sm sm:text-base">{descriptions}</p>
          </div>

          {/* Buttons */}
          {showbuttons && (
            <div className="flex flex-col sm:flex-row gap-4 mt-6">
              <Link to="/free-trial" onClick={onClose}>
                <button className="px-6 py-2 rounded-lg bg-green-500 text-white hover:bg-green-600 w-full sm:w-auto">
                  Free Trial
                </button>
              </Link>

              <button
                onClick={onClose}
                className="px-6 py-2 rounded-lg bg-gray-300 text-black hover:bg-gray-400 w-full sm:w-auto"
              >
                Cancel
              </button>
            </div>
          )}
        </div>

         {children && (
  <>
    <div>
      {children}
    </div>
  </>
)}
        

      </div>

    </div>
  );
};

export default PopUp;

